<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-progress-linear
                    v-if="isLoading"
                    color="primary"
                    indeterminate
                    class="mb-4"
                />
                <v-data-table
                    v-if="hasComments"
                    :headers="headers"
                    :items="comments"
                    :loading="isLoading"
                    :mobile-breakpoint="0"
                    disable-pagination
                    hide-default-footer
                >
                    <template #item.createdAt="{item}">
                        {{ formatDate(item.createdAt, true, true) }}
                    </template>
                    <template #item.author="{item}">
                        {{ item.author.id ? `${item.author.first_name + ' ' + item.author.last_name}` : item.author }}
                    </template>
                </v-data-table>
                <v-alert
                    v-else-if="!isLoading"
                    type="info"
                    text
                    border="left"
                >
                    Brak komentarzy do zamówienia.
                </v-alert>
            </v-col>
        </v-row>

        <v-row v-if="!docId" class="mt-2">
            <v-col cols="12">
                <v-alert
                    type="info"
                    text
                    border="left"
                >
                    Komentarze zostaną zapisane po utworzeniu dokumentu.
                </v-alert>
            </v-col>
        </v-row>

        <v-row class="mt-4">
            <v-col cols="12">
                <v-textarea
                    v-model="newComment"
                    label="Dodaj komentarz"
                    auto-grow
                    outlined
                    clearable
                    hide-details
                    :disabled="isCommentingDisabled"
                />
            </v-col>
            <v-col cols="12" class="d-flex justify-end">
                <v-btn
                    color="primary"
                    data-sentry-label="Wyślij komentarz"
                    :disabled="isSubmitDisabled"
                    :loading="isSubmitting"
                    @click="addComment"
                >
                    Wyślij
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import dateFormatter from '@/mixins/dateFormatter'

/* eslint-disable vue/no-mutating-props */
export default {
    name: 'CommentsTab',
    mixins: [dateFormatter],
    props: {
        document: {
            type: Object,
            default: null
        },
        canManageComments: {
            type: Boolean,
        }
    },
    data() {
        return {
            newComment: '',
            isLoading: false,
            isSubmitting: false,
            lastLoadedDocId: null,
            headers: [
                {
                    text: 'Treść',
                    value: 'content',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Autor',
                    value: 'author',
                    align: 'left',
                    sortable: false
                },
                {
                    text: 'Data i godzina utworzenia',
                    value: 'createdAt',
                    align: 'left',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        docId() {
            return this.document?.id || null
        },
        comments() {
            return this.document.comments
        },
        hasComments() {
            return this.comments.length > 0
        },
        isCommentingDisabled() {
            return this.isSubmitting || !this.canManageComments
        },
        isSubmitDisabled() {
            return this.isCommentingDisabled || !this.newComment || this.newComment.trim().length === 0
        },
        currentUser() {
            const state = this.$store.state.user

            return {
                id: state.userId,
                username: state.userName,
                firstName: state.userFirstName,
                lastName: state.userLastName
            }
        }
    },
    watch: {
        docId: {
            immediate: true,
            handler(newId) {
                if (!newId || newId === this.lastLoadedDocId) return

                this.loadComments(newId)
                this.lastLoadedDocId = newId
            }
        }
    },

    methods: {
        async loadComments(docOrderId) {
            this.isLoading = true

            try {
                const response = await this.$store.dispatch('documents/getDocumentComments', docOrderId)
                
                this.document.comments = response.data.results
            } catch {
                // error already handled in action
            } finally {
                this.isLoading = false
            }
        },
        async addComment() {
            const content = this.newComment ? this.newComment.trim() : ''

            if (!content) return

            if (!this.docId) {
                this.document.comments.push({
                    id: null,
                    content,
                    createdAt: '',
                    author: this.currentUser.username
                })
                this.newComment = ''

                return
            }

            this.isSubmitting = true

            try {
                await this.$store.dispatch('documents/createDocumentComment', {
                    docOrderId: this.docId,
                    content
                })
                this.newComment = ''
                await this.loadComments(this.docId)
            } catch {
                // error already handled in action
            } finally {
                this.isSubmitting = false
            }
        }
    }
}
</script>
